import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { getMovieDetails, getImageUrl } from '../services/api';

const MovieContainer = styled.div`
  padding-top: 70px;
  min-height: 100vh;
`;

const Backdrop = styled.div`
  height: 70vh;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)),
    url(${props => props.background}) center/cover no-repeat;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 40px;
`;

const Poster = styled.img`
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
`;

const Info = styled.div`
  color: white;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const MetaInfo = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 1.5rem;
  color: #b3b3b3;
`;

const Overview = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const Details = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 2rem;
`;

const DetailItem = styled.div`
  h3 {
    color: #b3b3b3;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1.1rem;
  }
`;

const MovieDetails = () => {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    const fetchMovieDetails = async () => {
      try {
        const data = await getMovieDetails(id);
        setMovie(data);
      } catch (error) {
        console.error('Error fetching movie details:', error);
      }
    };

    fetchMovieDetails();
  }, [id]);

  if (!movie) return null;

  return (
    <MovieContainer>
      <Backdrop background={getImageUrl(movie.backdrop_path, 'original')} />
      <Content>
        <Poster src={getImageUrl(movie.poster_path, 'w500')} alt={movie.title} />
        <Info>
          <Title>{movie.title}</Title>
          <MetaInfo>
            <span>{movie.release_date?.split('-')[0]}</span>
            <span>{Math.floor(movie.runtime / 60)}h {movie.runtime % 60}m</span>
            <span>{movie.vote_average.toFixed(1)}/10</span>
          </MetaInfo>
          <Overview>{movie.overview}</Overview>
          <Details>
            <DetailItem>
              <h3>Genre</h3>
              <p>{movie.genres?.map(genre => genre.name).join(', ')}</p>
            </DetailItem>
            <DetailItem>
              <h3>Language</h3>
              <p>{movie.original_language?.toUpperCase()}</p>
            </DetailItem>
            <DetailItem>
              <h3>Budget</h3>
              <p>${movie.budget?.toLocaleString()}</p>
            </DetailItem>
            <DetailItem>
              <h3>Revenue</h3>
              <p>${movie.revenue?.toLocaleString()}</p>
            </DetailItem>
          </Details>
        </Info>
      </Content>
    </MovieContainer>
  );
};

export default MovieDetails; 